module.exports = __webpack_public_path__ + "static/media/loginRotation2.671b38b1.png";